import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Widget, WidgetLoader } from "datastake-daf/dist/components";
import Tooltip from "./components/Tooltip";
import Chart from "../../../Modules/pme/screens/dashboard/widgets/sdgs/chart";

export default function Triangulation({
  data = {},
  loading,
}) {
  const { t } = useTranslation();

  const _renderTooltip = ({ mouseX, mouseY, item }) => {
    return (
      <Tooltip
        t={t}
        mouseY={mouseY}
        mouseX={mouseX}
        singleSources={(data.singleSource || 0) * 100}
        multipleSources={(data.multipleSource || 0) * 100}
      />
    )
  }

  const items = useMemo(() => [
    { percent: (data.multipleSource || 0), color: '#8DD5C9' },
    { percent: (data.singleSource || 0), color: '#227DC0' }
  ], [data]);

  return (
    <Widget
      title={t('Triangulation')}
      className="with-border-header flex-1 h-w-btn-header"
    >
      {!!loading && <WidgetLoader background="white" />}
      <div className="flex-1 flex flex-column justify-content-center">
        <Chart
          t={t}
          isEmpty
          data={items}
          yOffset={0}
          xOffset={130}
          withBody={false}
          mouseXOffset={10}
          mouseYOffset={10}
          renderTooltip={_renderTooltip}
          className="extra-small-chart"
        />
      </div>
    </Widget>
  )
}